// C-04 copy (UserFlows C-04, API.md §6.11–§6.12, Frontend §3.5, §6.6).
export const SETTINGS_COPY = {
  appointment:
    "What patients can book online. Lists come from Practice Fusion and don't sync on their own: refresh them when something changes in PF.",
  profile: "How patients reach you, and when you're open. Online booking only offers times inside your opening hours.",
  sources: 'Where bookings come from. Used to tag appointments and filter reports.',
  saved: 'Settings saved',
  unsaved: 'Unsaved changes',
  patientsSee: 'Patients see the new settings as soon as you save.',
  conflict: 'Settings were changed by someone else',
  synced: (added: number, removed: number) => `Synced: ${String(added)} new in PF, ${String(removed)} no longer in PF`,
  matches: 'Everything matches Practice Fusion',
  pfDown: "Couldn't reach Practice Fusion. Nothing was changed. Try again.",
  refreshRunning: 'A refresh is already running',
  rateLimited: (seconds: number) => `Try again in ${String(Math.max(1, Math.ceil(seconds / 60)))} min`,
  /** No UserFlows copy before the first sync (task 04 assumption). */
  neverSynced: 'Never synced with PF',
}
